import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { DiscordMessageCard } from "./DiscordMessageCard";
import { useContent } from "@/context/ContentContext";
import { useText } from "@/lib/useText";

const KIND = { updates: "Update", giveaways: "Giveaway", events: "Evento" };

export function LatestNews() {
  const { preview } = useContent();
  const t = useText();
  const [messages, setMessages] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/discord/latest?limit=3").then(({ data }) => alive && setMessages(data.messages)).catch(() => alive && setMessages([]));
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!messages || messages.length === 0) return null;

  return (
    <section data-reveal className="border-t border-eden-border py-20 sm:py-28" aria-labelledby="ultimas-title" data-testid="latest-news-section">
      <div className="container-eden">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="eyebrow mb-4">{t("latest_eyebrow")}</p>
            <h2 id="ultimas-title" className="text-2xl font-bold tracking-tight text-eden-text sm:text-3xl lg:text-4xl">{t("latest_title")}</h2>
          </div>
          <Link to={`/novidades${preview ? "?preview=1" : ""}`} className="inline-flex items-center gap-1.5 text-sm font-medium text-eden-secondary transition-colors hover:text-eden-orange" data-testid="latest-news-all-link">
            {t("latest_all")} <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
        <div className="mt-10 grid gap-6 md:grid-cols-3" data-testid="latest-news-grid">
          {messages.map((m) => (
            <div key={m.id} className="relative">
              <span className="absolute right-4 top-4 z-10 rounded-sm border border-eden-border bg-eden-bg px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest text-eden-turquoise" data-testid={`latest-news-kind-${m.id}`}>{KIND[m.kind]}</span>
              <DiscordMessageCard msg={m} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
